import isEmpty from 'lodash.isempty';
import i18next from '../../i18n';

export const rejectErrorCodeHelper = (error) => {
  if (error?.response?.data?.ErrorMessage) {
    return error?.response?.data?.ErrorMessage;
  }

  return i18next.t('apiErrors.SomethingWentWrong');
};

export function formatErrorMessage(error) {
  const errorCode = error?.response?.data?.Errors[0]?.Code;

  if (errorCode === 'SocureKYCError') {
    const errorMessage = error?.response?.data?.Errors[0]?.Message;
    return errorMessage.slice(30);
  }

  return i18next.t(`apiErrors.${errorCode}`);
}

export function handleOnCompleteError(error) {
  const errorResponse = error?.response;
  const errorData = errorResponse?.data;
  const errorsList = errorData?.Errors;
  const errorCode = errorsList[0].Code;
  return i18next.t(`apiErrors.${errorCode}`);
}

export function handleBankAccountError({ error, setErrorMessages }) {
  const errorResponse = error.response;
  const errorData = errorResponse.data;
  const list = errorData.Errors;
  const errorMessage = (error) => {
    switch (error.Context) {
      case 'CanAddBankAccount':
        if (error.Code === 'WizardValidation_InvalidApplicationStepType') {
          setErrorMessages([
            i18next.t('fields.errors.validation.invalidApplicationStep'),
          ]);
        } else {
          setErrorMessages(
            list
              .filter(
                (errorObject) => errorObject.Context === 'CanAddBankAccount',
              )
              .map((e) => e.Message),
          );
        }
        break;
      default:
        break;
    }
  };

  if (!isEmpty(list)) {
    list.map((error) => {
      errorMessage(error);

      return null;
    });
  }

  return null;
}

export function handleErrorBasedOnCode(error, onError) {
  const errorData = error?.response?.data;
  const list = errorData.Errors;

  const errorMessage = (error) => {
    switch (error.Code) {
      case 'StreetIsNullOrEmpty':
      case 'StreetIsInvalidLength':
        onError('Street', {
          type: 'manual',
          message: i18next.t(`apiErrors.${error.Code}`),
        });
        break;
      case 'CityIsNullOrEmpty':
      case 'CityIsInvalidLength':
        onError('City', {
          type: 'manual',
          message: i18next.t(`apiErrors.${error.Code}`),
        });
        break;
      case 'CountryIso3CodeIsNullOrEmpty':
      case 'CountryIso3CodeIsInvalidLength':
      case 'CountryIso3CodeIsInvalid':
        onError('CountryIso3CodeIsInvalid', {
          type: 'manual',
          message: i18next.t(`apiErrors.${error.Code}`),
        });
        break;
      case 'PostalCodeIsNullOrEmpty':
      case 'PostalCodeIsInvalidLength':
      case 'PostalCodeNotValid':
      case 'PostalCodeIsInvalid':
        onError('PostalCode', {
          type: 'manual',
          message: i18next.t(`apiErrors.${error.Code}`),
        });
        break;
      case 'StateIsNullOrEmpty':
      case 'StateIsInvalidLength':
      case 'GiftStateNotSupported':
        onError('State', {
          type: 'manual',
          message: i18next.t(`apiErrors.${error.Code}`),
        });
        break;

      default:
        break;
    }
  };

  if (!isEmpty(list)) {
    list.map((error) => {
      errorMessage(error);

      return null;
    });
  }

  return null;
}
